/**
 * @generated SignedSource<<bd9270780efe7793ddcaddb5479127b9>>
 * @relayHash 3e38f27834e6d0f75780ab4a60869dd9
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c61e83de28bceea71d0d58856c4efe9981d1e01b2ae749dc6a388cb5fad3f109

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type operationChecksPageQuery$variables = {
  account: string;
  graph: string;
};
export type operationChecksPageQuery$data = {
  readonly graphByAccountSlug: {
    readonly " $fragmentSpreads": FragmentRefs<"branchesFragment" | "excludedClientsFragment" | "excludedOperationsFragment" | "timeRangeFragment">;
  };
};
export type operationChecksPageQuery = {
  response: operationChecksPageQuery$data;
  variables: operationChecksPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "account"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "graph"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "accountSlug",
    "variableName": "account"
  },
  {
    "kind": "Variable",
    "name": "graphSlug",
    "variableName": "graph"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "operationChecksEnabled",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "operationChecksIgnoreUsageData",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "operationChecksSchemaProposalApprovalEnabled",
    "storageKey": null
  },
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "operationChecksPageQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*: any*/),
          "concreteType": "Graph",
          "kind": "LinkedField",
          "name": "graphByAccountSlug",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "excludedOperationsFragment"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "excludedClientsFragment"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "timeRangeFragment"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "branchesFragment"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "operationChecksPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Graph",
        "kind": "LinkedField",
        "name": "graphByAccountSlug",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphOperationCheckConfiguration",
            "kind": "LinkedField",
            "name": "operationChecksConfiguration",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "excludedOperations",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "excludedClients",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "requestCountThreshold",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timeRangeDays",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Branch",
            "kind": "LinkedField",
            "name": "productionBranch",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BranchConnection",
            "kind": "LinkedField",
            "name": "branches",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Branch",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": (v3/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3e38f27834e6d0f75780ab4a60869dd9",
    "id": "c61e83de28bceea71d0d58856c4efe9981d1e01b2ae749dc6a388cb5fad3f109",
    "metadata": {},
    "name": "operationChecksPageQuery",
    "operationKind": "query",
    "text": "query operationChecksPageQuery(\n  $account: String!\n  $graph: String!\n) {\n  graphByAccountSlug(accountSlug: $account, graphSlug: $graph) {\n    ...excludedOperationsFragment\n    ...excludedClientsFragment\n    ...timeRangeFragment\n    ...branchesFragment\n    id\n  }\n}\n\nfragment branchItemChecksConfigurationFragment on Branch {\n  name\n  operationChecksEnabled\n  operationChecksIgnoreUsageData\n  operationChecksSchemaProposalApprovalEnabled\n}\n\nfragment branchesFragment on Graph {\n  productionBranch {\n    name\n    ...branchItemChecksConfigurationFragment\n    id\n  }\n  branches {\n    nodes {\n      name\n      ...branchItemChecksConfigurationFragment\n      id\n    }\n  }\n}\n\nfragment excludedClientsFragment on Graph {\n  operationChecksConfiguration {\n    excludedClients\n  }\n  id\n}\n\nfragment excludedOperationsFragment on Graph {\n  operationChecksConfiguration {\n    excludedOperations\n  }\n  id\n}\n\nfragment timeRangeFragment on Graph {\n  id\n  operationChecksConfiguration {\n    requestCountThreshold\n    timeRangeDays\n  }\n}\n"
  }
};
})();

(node as any).hash = "c8963436f387d3ad0ae3d3da720ce85a";

export default node;
